import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';

const Profile = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('profile');
  const [userData, setUserData] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [bookings, setBookings] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [editFormData, setEditFormData] = useState({});
  const [profileLoading, setProfileLoading] = useState(true);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [detailLoading, setDetailLoading] = useState(false);
  const [loadingBookingId, setLoadingBookingId] = useState(null);

  // ✅ Get userId from localStorage
  const userId = localStorage.getItem('userId');

  useEffect(() => {
    const user = localStorage.getItem('user');
    const isAuth = localStorage.getItem('isAuthenticated');

    if (!user || !userId || !isAuth) {
      navigate('/login');
      return;
    }





    // ✅ Fetch profile data from API with x-user-id header (lowercase)
    const fetchProfileData = async () => {
      try {
        setProfileLoading(true);

        const token = localStorage.getItem('token');

        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/v1/profile/`,
          {
            headers: {
              Accept: 'application/json',
              Authorization: `Bearer ${token}`
            }
          }
        );

        if (response.data.status === 200) {
          const userDetail = response.data.data.user_detail;
          console.log('Profile API response:', userDetail);

          setUserData(userDetail);
          setEditFormData({
            ...userDetail,
            password: ''
          });

          localStorage.setItem('user', JSON.stringify(userDetail));
          localStorage.setItem('userName', userDetail.name);
          localStorage.setItem('userEmail', userDetail.email);
          localStorage.setItem('userMobile', userDetail.mobile);
        }

      } catch (err) {
        console.error('Error fetching profile:', err);
      } finally {
        setProfileLoading(false);
      }
    };

    fetchProfileData();
  }, [navigate, userId]);


  // ✅ Fetch User Bookings
  const fetchUserBookings = async () => {
    try {

      const token = localStorage.getItem('token');

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/booking/`,
        {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
          }
        }
      );

      console.log('Bookings API response:', response.data);

      if (response.data.status === 200) {
        const bookingList =
          response.data.data.booking_list || [];

        setBookings(bookingList);

        console.log(
          'Bookings fetched successfully:',
          bookingList
        );
      }

    } catch (err) {
      console.error('Error fetching bookings:', err);
      toast.error('Failed to fetch bookings');
    }
  };


  // ✅ Fetch Booking Detail
  const fetchBookingDetail = async (bookingId) => {

    try {

      setLoadingBookingId(bookingId);
      setDetailLoading(true);

      const token = localStorage.getItem('token');

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/booking/${bookingId}/`,
        {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
          }
        }
      );

      if (response.data.status === 200) {

        setSelectedBooking(
          response.data.data.booking_detail
        );

      }

    } catch (err) {

      toast.error(
        'Failed to fetch booking details'
      );

    } finally {

      setDetailLoading(false);
      setLoadingBookingId(null);

    }
  };



  // ✅ Fetch User Transactions
  const fetchUserTransactions = async () => {
    try {
      const token = localStorage.getItem('token');

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/transaction/`,
        {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
          }
        }
      );

      console.log('Transactions API response:', response.data);

      if (response.data.status === 200) {
        const transactionList =
          response.data.data.transaction_list || [];

        setTransactions(transactionList);

        console.log(
          'Transactions fetched successfully:',
          transactionList
        );
      }

    } catch (err) {
      console.error('Error fetching transactions:', err);
      toast.error('Failed to fetch transactions');
    }
  };




  // ✅ Cancel Booking
const handleCancelBooking = async (bookingId) => {

  const confirmCancel = window.confirm(
    'Are you sure you want to cancel this booking?'
  );

  if (!confirmCancel) return;

  try {

    const token = localStorage.getItem('token');

    const response = await axios.patch(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/booking/${bookingId}/cancel/`,
      {
        status: 599,
        message: 'cancel',
        data: 'test'
      },
      {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`
        }
      }
    );

    console.log(
      'Cancel Booking Response:',
      response.data
    );

    if (response.data.status === 200) {

      toast.success(
        'Booking cancelled successfully!'
      );

      fetchUserBookings();

      if (
        selectedBooking?.id === bookingId
      ) {
        setSelectedBooking(null);
      }

    }

  } catch (err) {

    console.error(
      'Cancel Booking Error:',
      err.response?.data || err
    );

    toast.error(
      err.response?.data?.message ||
      'Failed to cancel booking'
    );

  }
};

  const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('userId');
    localStorage.removeItem('user_id');
    localStorage.removeItem('userName');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('userMobile');
    localStorage.removeItem('token');
    localStorage.removeItem('isAuthenticated');
    toast.success('Logged out successfully!');
    navigate('/login');
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // ✅ Save / Update Profile
  const handleSaveProfile = async () => {
    try {
      setIsLoading(true);

      const token = localStorage.getItem('token');

      const response = await axios.patch(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/profile/edit/`,
        {
          name: editFormData.name,
          email: editFormData.email,
          mobile: editFormData.mobile,
          password: editFormData.password || ""
        },
        {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
          }
        }
      );

      console.log('Edit Profile Response:', response.data);

      if (response.data.status === 200) {

        const updatedUser =
          response.data.data.user_detail;

        setUserData(updatedUser);
        setEditFormData({
          ...updatedUser,
          password: ''
        });

        localStorage.setItem(
          'user',
          JSON.stringify(updatedUser)
        );

        localStorage.setItem(
          'userName',
          updatedUser.name
        );

        localStorage.setItem(
          'userEmail',
          updatedUser.email
        );

        localStorage.setItem(
          'userMobile',
          updatedUser.mobile
        );

        toast.success('Profile updated successfully!');
        setEditMode(false);
      }

    } catch (err) {

      console.error(
        'Profile Update Error:',
        err.response?.data || err
      );

      toast.error(
        err.response?.data?.message ||
        'Failed to update profile'
      );

    } finally {
      setIsLoading(false);
    }
  };

  // ✅ Show loading state while fetching profile
  if (profileLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }



  return (
    <>
      <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        body {
          font-family: 'Poppins', sans-serif;
          background-color: #f8f9fa;
          padding: 0;
        }

        .profile-container {
          display: flex;
          min-height: 100vh;
          background-color: #f8f9fa;
        }

        .sidebar {
          width: 280px;
          background: linear-gradient(135deg, #6B2A00 0%, #8B3A00 100%);
          color: white;
          padding: 0;
          position: fixed;
          left: 0;
          top: 0;
          height: 100vh;
          overflow-y: auto;
          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
        }

        .sidebar-header {
          padding: 30px 20px;
          text-align: center;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }

        .sidebar-avatar {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.2);
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 15px;
          font-size: 40px;
          border: 3px solid #E3952A;
        }

        .sidebar-name {
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 5px;
        }

        .sidebar-email {
          font-size: 12px;
          opacity: 0.8;
        }

        .sidebar-nav {
          padding: 30px 0;
        }

        .nav-item {
          padding: 15px 25px;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          gap: 15px;
          color: rgba(255, 255, 255, 0.8);
          border-left: 4px solid transparent;
          font-size: 14px;
          font-weight: 500;
        }

        .nav-item:hover,
        .nav-item.active {
          background-color: rgba(255, 255, 255, 0.1);
          border-left-color: #E3952A;
          color: white;
        }

        .nav-item i {
          font-size: 18px;
          width: 20px;
          text-align: center;
        }

        .nav-divider {
          height: 1px;
          background: rgba(255, 255, 255, 0.1);
          margin: 15px 0;
        }

        .logout-btn {
          position: absolute;
          bottom: 30px;
          left: 25px;
          right: 25px;
          padding: 12px;
          background: #E3952A;
          color: #6B2A00;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          font-weight: 600;
          transition: all 0.3s ease;
          width: calc(100% - 50px);
        }

        .logout-btn:hover {
          background: #fff;
          transform: translateY(-2px);
        }

        .main-content {
          flex: 1;
          margin-left: 280px;
          padding: 40px;
        }

        .content-header {
          margin-bottom: 30px;
        }

        .content-header h1 {
          font-size: 32px;
          color: #6B2A00;
          font-weight: 700;
          margin-bottom: 10px;
        }

        .content-header p {
          color: #999;
          font-size: 14px;
        }

        .profile-card {
          background: white;
          border-radius: 15px;
          padding: 40px;
          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
          margin-bottom: 30px;
        }

        .profile-avatar {
          width: 120px;
          height: 120px;
          border-radius: 50%;
          background: linear-gradient(135deg, #6B2A00 0%, #E3952A 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 30px;
          font-size: 50px;
          border: 5px solid #E3952A;
          box-shadow: 0 5px 20px rgba(107, 42, 0, 0.2);
        }

        .upload-btn {
          background: #E3952A;
          color: white;
          padding: 10px 20px;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          font-weight: 600;
          display: block;
          margin: 0 auto 30px;
          transition: all 0.3s ease;
        }

        .upload-btn:hover {
          background: #6B2A00;
        }

        .profile-info {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 30px;
          margin-bottom: 30px;
        }

        .info-group {
          display: flex;
          flex-direction: column;
        }

        .info-label {
          font-size: 12px;
          color: #999;
          margin-bottom: 8px;
          text-transform: uppercase;
          letter-spacing: 1px;
          font-weight: 600;
        }

        .info-value {
          font-size: 16px;
          color: #333;
          font-weight: 500;
        }

        .info-input {
          width: 100%;
          padding: 12px;
          border: 2px solid #E0E0E0;
          border-radius: 8px;
          font-size: 14px;
          transition: all 0.3s ease;
        }

        .info-input:focus {
          outline: none;
          border-color: #E3952A;
          box-shadow: 0 0 0 3px rgba(227, 149, 42, 0.1);
        }

        .edit-actions {
          display: flex;
          gap: 15px;
          margin-top: 30px;
        }

        .edit-btn,
        .save-btn,
        .cancel-btn {
          padding: 12px 30px;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          font-weight: 600;
          transition: all 0.3s ease;
          font-size: 14px;
        }

        .edit-btn {
          background: #E3952A;
          color: white;
          flex: 1;
        }

        .save-btn {
          background: #6B2A00;
          color: white;
          flex: 1;
        }

        .cancel-btn {
          background: #E0E0E0;
          color: #333;
          flex: 1;
        }

        .booking-card {
          background: white;
          border-radius: 12px;
          padding: 20px;
          margin-bottom: 20px;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
          border-left: 5px solid #E3952A;
        }

        .booking-header {
          display: flex;
          justify-content: space-between;
          align-items: start;
          margin-bottom: 15px;
        }

        .booking-title {
          font-size: 18px;
          font-weight: 700;
          color: #6B2A00;
        }

        .booking-status {
          padding: 6px 15px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
        }

        .status-confirmed {
          background: #d4edda;
          color: #155724;
        }

        .status-pending {
          background: #fff3cd;
          color: #856404;
        }

        .status-cancelled {
          background: #f8d7da;
          color: #721c24;
        }

        .booking-details {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 15px;
          margin-bottom: 15px;
          font-size: 14px;
        }

        .detail-item {
          display: flex;
          flex-direction: column;
          gap: 5px;
        }

        .detail-label {
          color: #999;
          font-weight: 600;
          font-size: 12px;
        }

        .detail-value {
          color: #333;
          font-weight: 500;
        }

        .booking-actions {
          display: flex;
          gap: 10px;
          margin-top: 15px;
        }

        .action-btn {
          padding: 8px 15px;
          border: 2px solid #E3952A;
          background: transparent;
          color: #E3952A;
          border-radius: 6px;
          cursor: pointer;
          font-size: 12px;
          font-weight: 600;
          transition: all 0.3s ease;
        }

        .action-btn:hover {
          background: #E3952A;
          color: white;
        }

        .empty-state {
          text-align: center;
          padding: 60px 20px;
        }

        .empty-state i {
          font-size: 60px;
          color: #E3952A;
          margin-bottom: 20px;
        }

        .empty-state h3 {
          color: #333;
          margin-bottom: 10px;
        }

        .empty-state p {
          color: #999;
        }

        .transaction-table {
          width: 100%;
          background: white;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
        }

        .table-head {
          background: #6B2A00;
          color: white;
        }

        .table-head th {
          padding: 15px;
          font-weight: 600;
          font-size: 13px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .table-body td {
          padding: 15px;
          border-bottom: 1px solid #f0f0f0;
          font-size: 14px;
        }

        .table-body tr:hover {
          background: #f9f9f9;
        }

        .amount-positive {
          color: #28a745;
          font-weight: 600;
        }

        .amount-negative {
          color: #dc3545;
          font-weight: 600;
        }

        @media (max-width: 768px) {
          .sidebar {
            width: 0;
            transform: translateX(-100%);
          }

          .main-content {
            margin-left: 0;
            padding: 20px;
          }

          .profile-info {
            grid-template-columns: 1fr;
          }

          .booking-details {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      <div className="profile-container">
        {/* Sidebar */}
        <div className="sidebar">
          <div className="sidebar-header">
            <div className="sidebar-avatar">
              <i className="fas fa-user"></i>
            </div>
            <div className="sidebar-name">{userData?.name || 'User'}</div>
            <div className="sidebar-email">{userData?.email || 'email@example.com'}</div>
          </div>

          <div className="sidebar-nav">
            <div
              className={`nav-item ${activeTab === 'profile' ? 'active' : ''}`}
              onClick={() => setActiveTab('profile')}
            >
              <i className="fas fa-user-circle"></i>
              <span>Profile</span>
            </div>

            {/* <div
              className={`nav-item ${activeTab === 'complete' ? 'active' : ''}`}
              onClick={() => setActiveTab('complete')}
            >
              <i className="fas fa-tasks"></i>
              <span>Profile Complete</span>
            </div> */}

            <div
              className={`nav-item ${activeTab === 'bookings' ? 'active' : ''}`}
              onClick={() => {
                setActiveTab('bookings');
                fetchUserBookings();
              }}
            >
              <i className="fas fa-calendar-alt"></i>
              <span>My Bookings</span>
            </div>

            {/* <div
              className={`nav-item ${activeTab === 'cancel' ? 'active' : ''}`}
              onClick={() => setActiveTab('cancel')}
            >
              <i className="fas fa-ban"></i>
              <span>Cancelled Bookings</span>
            </div> */}

            <div
              className={`nav-item ${activeTab === 'transactions' ? 'active' : ''}`}
              onClick={() => {
                setActiveTab('transactions');
                fetchUserTransactions();
              }}
            >
              <i className="fas fa-history"></i>
              <span>Transaction History</span>
            </div>

            <div className="nav-divider"></div>

            <button className="logout-btn" onClick={handleLogout}>
              <i className="fas fa-sign-out-alt"></i> Logout
            </button>
          </div>
        </div>

        {/* Main Content */}
        <div className="main-content">
          {/* Profile Section */}
          {activeTab === 'profile' && userData && (
            <>
              <div className="content-header">
                <h1>My Account</h1>
                <p>Manage your profile, addresses, and preferences</p>
              </div>

              <div className="profile-card">
                <div className="profile-avatar">
                  <i className="fas fa-user"></i>
                </div>
                <button className="upload-btn">📤 Upload Photo</button>

                {!editMode ? (
                  <>
                    <div className="profile-info">
                      <div className="info-group">
                        <div className="info-label">First Name</div>
                        <div className="info-value">{userData.name?.split(' ')[0]}</div>
                      </div>
                      <div className="info-group">
                        <div className="info-label">Last Name</div>
                        <div className="info-value">{userData.name?.split(' ')[1] || ''}</div>
                      </div>
                      <div className="info-group">
                        <div className="info-label">Email Address</div>
                        <div className="info-value">{userData.email}</div>
                      </div>
                      <div className="info-group">
                        <div className="info-label">Phone Number</div>
                        <div className="info-value">+91{userData.mobile}</div>
                      </div>
                    </div>

                    <div className="edit-actions">
                      <button
                        className="edit-btn"
                        onClick={() => setEditMode(true)}
                      >
                        <i className="fas fa-edit"></i> Edit Profile
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="profile-info">
                      <div className="info-group">
                        <div className="info-label">First Name</div>
                        <input
                          type="text"
                          className="info-input"
                          name="firstName"
                          value={editFormData.name?.split(' ')[0] || ''}
                          onChange={(e) => {
                            const nameParts = editFormData.name?.split(' ') || ['', ''];
                            nameParts[0] = e.target.value;
                            setEditFormData({
                              ...editFormData,
                              name: nameParts.join(' ')
                            });
                          }}
                        />
                      </div>
                      <div className="info-group">
                        <div className="info-label">Last Name</div>
                        <input
                          type="text"
                          className="info-input"
                          name="lastName"
                          value={editFormData.name?.split(' ')[1] || ''}
                          onChange={(e) => {
                            const nameParts = editFormData.name?.split(' ') || ['', ''];
                            nameParts[1] = e.target.value;
                            setEditFormData({
                              ...editFormData,
                              name: nameParts.join(' ')
                            });
                          }}
                        />
                      </div>
                      <div className="info-group">
                        <div className="info-label">Email Address</div>
                        <input
                          type="email"
                          className="info-input"
                          name="email"
                          value={editFormData.email || ''}
                          onChange={handleEditChange}
                        />
                      </div>
                      <div className="info-group">
                        <div className="info-label">Phone Number</div>
                        <input
                          type="tel"
                          className="info-input"
                          name="mobile"
                          value={editFormData.mobile || ''}
                          onChange={handleEditChange}
                        />
                      </div>



                      <div className="info-group">
                        <div className="info-label">
                          Password
                        </div>

                        <input
                          type="password"
                          className="info-input"
                          name="password"
                          placeholder="Enter new password"

                          value={editFormData.password || ''}

                          onChange={handleEditChange}
                        />
                      </div>
                    </div>

                    <div className="edit-actions">
                      <button
                        className="save-btn"
                        onClick={handleSaveProfile}
                        disabled={isLoading}
                      >
                        {isLoading ? 'Saving...' : '✓ Save Changes'}
                      </button>
                      <button
                        className="cancel-btn"
                        onClick={() => {
                          setEditMode(false);

                          setEditFormData({
                            ...userData,
                            password: ''
                          });
                        }}
                      >
                        ✕ Cancel
                      </button>
                    </div>
                  </>
                )}
              </div>
            </>
          )}

          {/* Profile Complete Section */}
          {activeTab === 'complete' && (
            <>
              <div className="content-header">
                <h1>Complete Your Profile</h1>
                <p>Add more information to your account</p>
              </div>

              <div className="profile-card">
                <div style={{ textAlign: 'center', padding: '40px' }}>
                  <i className="fas fa-check-circle" style={{ fontSize: '60px', color: '#E3952A', marginBottom: '20px' }}></i>
                  <h3>Your profile is complete!</h3>
                  <p style={{ color: '#999', marginTop: '10px' }}>All necessary information has been added.</p>
                </div>
              </div>
            </>
          )}


          {/* Bookings Section */}
          {activeTab === 'bookings' && (
            <>
              <div className="content-header">
                <h1>My Bookings</h1>
                <p>View all your puja bookings</p>
              </div>

              <div className="profile-card">

                {bookings.length === 0 ? (

                  <div className="empty-state">
                    <i className="fas fa-calendar-times"></i>
                    <h3>No Bookings Yet</h3>
                    <p>You haven't booked any puja services yet.</p>
                  </div>

                ) : (

                  bookings.map((booking, index) => (

                    <div
                      key={index}
                      className="booking-card"
                    >

                      <div className="booking-header">

                        <div className="booking-title">
                          {booking.puja_name}
                        </div>

                        <span
                          className={`booking-status ${booking.status === 0
                              ? 'status-confirmed'
                              : booking.status === 1
                                ? 'status-pending'
                                : 'status-cancelled'
                            }`}
                        >
                          {
                           booking.status === 0
? 'CONFIRMED'
: booking.status === 1
? 'PENDING'
: booking.status === 3
? 'CANCELLED'
: 'UNKNOWN'
                          }
                        </span>

                      </div>

                      <div className="booking-details">

                        <div className="detail-item">
                          <img
                            src={booking.puja_image}
                            alt={booking.puja_name}
                            style={{
                              width: '100%',
                              height: '160px',
                              objectFit: 'cover',
                              borderRadius: '10px'
                            }}
                          />
                        </div>

                        <div className="detail-item">
                          <div className="detail-label">
                            Pandit
                          </div>

                          <div className="detail-value">
                            {booking.pandit_name}
                          </div>
                        </div>

                        <div className="detail-item">
                          <div className="detail-label">
                            Date
                          </div>

                          <div className="detail-value">
                            {new Date(
                              booking.puja_date
                            ).toLocaleDateString('en-IN')}
                          </div>
                        </div>

                        <div className="detail-item">
                          <div className="detail-label">
                            Amount
                          </div>

                          <div className="detail-value">
                            ₹{Number(
                              booking.total_amount
                            ).toLocaleString('en-IN')}
                          </div>
                        </div>

                      </div>

                      <div className="booking-actions">

                        <button
                          className="action-btn"
                          onClick={() =>
                            fetchBookingDetail(booking.id)
                          }
                          disabled={
                            detailLoading &&
                            loadingBookingId === booking.id
                          }
                        >

                          {
                            detailLoading &&
                              loadingBookingId === booking.id
                              ? 'Loading...'
                              : 'View Details'
                          }

                        </button>

                        {
booking.status === 0 && (

<button
  className="action-btn"
  style={{
    borderColor:'#dc3545',
    color:'#dc3545'
  }}
  onClick={() =>
    handleCancelBooking(
      booking.id
    )
  }
>

Cancel Booking

</button>

)
}

                      </div>

                    </div>

                  ))

                )}

              </div>


              {selectedBooking && (

                <div
                  style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'rgba(0,0,0,.6)',
                    zIndex: 9999,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >

                  <div
                    style={{
                      background: '#fff',
                      width: '90%',
                      maxWidth: '900px',
                      padding: '30px',
                      borderRadius: '16px',
                      maxHeight: '90vh',
                      overflow: 'auto'
                    }}
                  >

                    <h3>
                      Booking Details
                    </h3>

                    <img
                      src={selectedBooking.puja_image}
                      alt=""
                      style={{
                        width: '100%',
                        height: '220px',
                        objectFit: 'cover',
                        borderRadius: '12px',
                        marginBottom: '20px'
                      }}
                    />

                    <div className="booking-details">

                      <div className="detail-item">
                        <div className="detail-label">
                          Puja
                        </div>
                        <div className="detail-value">
                          {selectedBooking.puja_name}
                        </div>
                      </div>

                      <div className="detail-item">
                        <div className="detail-label">
                          Pandit
                        </div>
                        <div className="detail-value">
                          {selectedBooking.pandit_name}
                        </div>
                      </div>

                      <div className="detail-item">
                        <div className="detail-label">
                          Customer
                        </div>
                        <div className="detail-value">
                          {selectedBooking.customer_name}
                        </div>
                      </div>

                      <div className="detail-item">
                        <div className="detail-label">
                          Mobile
                        </div>
                        <div className="detail-value">
                          {selectedBooking.customer_mobile}
                        </div>
                      </div>

                      <div className="detail-item">
                        <div className="detail-label">
                          Mode
                        </div>
                        <div className="detail-value">
                          {selectedBooking.puja_mode}
                        </div>
                      </div>

                      <div className="detail-item">
                        <div className="detail-label">
                          Samagari
                        </div>
                        <div className="detail-value">
                          {selectedBooking.puja_samagari}
                        </div>
                      </div>

                      <div className="detail-item">
                        <div className="detail-label">
                          Payment
                        </div>
                        <div className="detail-value">
                          {selectedBooking.pay_mode}
                        </div>
                      </div>

                      <div className="detail-item">
                        <div className="detail-label">
                          Total Amount
                        </div>
                        <div className="detail-value">
                          ₹{selectedBooking.total_amount}
                        </div>
                      </div>

                    </div>

                    {
selectedBooking?.status === 0 && (

<button
  className="save-btn"
  style={{
    background:'#dc3545',
    marginBottom:'15px'
  }}
  onClick={() =>
    handleCancelBooking(
      selectedBooking.id
    )
  }
>

Cancel Booking

</button>

)
}

                    <button
                      className="cancel-btn"
                      onClick={() =>
                        setSelectedBooking(null)
                      }
                    >

                      Close

                    </button>

                  </div>

                </div>
              )}

            </>
          )}

              





              {/* Cancelled Bookings Section */}
              {activeTab === 'cancel' && (
                <>
                  <div className="content-header">
                    <h1>Cancelled Bookings</h1>
                    <p>View your cancelled bookings</p>
                  </div>

                  <div className="profile-card">
                    <div className="empty-state">
                      <i className="fas fa-trash-alt"></i>
                      <h3>No Cancelled Bookings</h3>
                      <p>You don't have any cancelled bookings.</p>
                    </div>
                  </div>
                </>
              )}


              {/* Transactions Section */}
              {activeTab === 'transactions' && (
                <>
                  <div className="content-header">
                    <h1>Transaction History</h1>
                    <p>All your payment transactions</p>
                  </div>

                  <div className="profile-card">
                    {transactions.length === 0 ? (
                      <div className="empty-state">
                        <i className="fas fa-receipt"></i>
                        <h3>No Transactions Found</h3>
                        <p>You don't have any transactions yet.</p>
                      </div>
                    ) : (
                      <div className="transaction-table">
                        <table style={{ width: '100%' }}>
                          <thead className="table-head">
                            <tr>
                              <th>ID</th>
                              <th>Booking ID</th>
                              <th>Transaction ID</th>
                              <th>Amount</th>
                              <th>Status</th>
                              <th>Date</th>
                            </tr>
                          </thead>

                          <tbody className="table-body">
                            {transactions.map((item, index) => (
                              <tr key={index}>
                                <td>#{item.id}</td>

                                <td>#{item.booking_id}</td>

                                <td>
                                  {item.transaction_id || 'N/A'}
                                </td>

                                <td className="amount-negative">
                                  ₹{Number(item.amount).toLocaleString('en-IN')}
                                </td>

                                <td>
                               <span
  className={`booking-status ${
    item.status === 0
      ? 'status-confirmed'
      : item.status === 1
      ? 'status-pending'
      : item.status === 3
      ? 'status-cancelled'
      : 'status-cancelled'
  }`}
>

{
item.status === 0
? 'SUCCESS'
: item.status === 1
? 'PENDING'
: item.status === 3
? 'CANCELLED'
: 'FAILED'
}

</span>
                                </td>

                                <td>
                                  {new Date(item.created_at).toLocaleDateString(
                                    'en-IN',
                                    {
                                      day: '2-digit',
                                      month: 'short',
                                      year: 'numeric'
                                    }
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </>
              )}


          </div>
</div>

<ToastContainer
  position="top-right"
  autoClose={3000}
  hideProgressBar={false}
  newestOnTop={true}
  closeOnClick
  rtl={false}
  pauseOnFocusLoss
  draggable
  pauseOnHover
/>

    </>
  );
};

export default Profile;